module.exports = __webpack_public_path__ + "ellipse.png";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/landing/assets/ellipse.png
// module id = 1185
// module chunks = 10